import React from 'react'
import Helmet from 'react-helmet'

const forofourPage = (props) => (
    <div>
        <Helmet>
            <title>404 | Page Not Found</title>
            <meta name="description" content="404. Sorry this page cannot be found, something went wrong or the page route doesnt exist." />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>404</h1>
                    </header>
                    <h2>OOPS, SORRY WE CANT FIND THAT PAGE!</h2>
                    <p>Either something went wrong or the page route doesnt exist</p>
                    <a href="/" className="button">HOME PAGE</a>
                    <br/>
                </div>
            </section>
        </div>

    </div>
)

export default forofourPage


// WEBPACK FOOTER //
// ./src/pages/404.js